import { SourceRule } from "./sourceRule.dto";

export enum NodeValue {
  FALSE = 0,
  TRUE = 1,
  UNKNOWN = 2,
  UNDECIDED = 3,
}

export enum LogicalOperator {
  AND = "AND",
  OR = "OR",
  NOT = "NOT",
}

export enum EvaluationMethod {
  LLM_CONVERSATION = 0,
}

export enum ConfidenceLevel {
  LOW = 0,
  MEDIUM = 1,
  HIGH = 2,
}

export interface Explanation {
  id: string;
  name: string;
  operator?: LogicalOperator;

  is_on_answer_path?: boolean;
  evaluation: NodeValue;
  evaluation_method: EvaluationMethod;
  confidence_level: ConfidenceLevel;
  derived_from: string[];
  evidence?: string;
  children: Explanation[];
  source_rules: SourceRule[];
}
